import React, {useEffect, useRef} from 'react';
import hkMpegts from '@baidu/haokan-mpegts';
import hkArtplayer from '../../../../../utils/artplayer';

const FlvPlayer = ({url}) => {
    const flvPlayerRef = useRef(null);

    useEffect(() => {
        if (url) {
            videoInit(url);
        }
    }, [url]);

    const videoInit = async () => {
        const $art = new hkArtplayer({
            container: '#flv-video-container',
            mutex: true, // 播放器是否互斥，即只有一个播放器
            lang: 'zh-cn', // 本地语言
            hotkey: true, // 使用快捷键
            autoSize: true, // 视频比例自动适配播放器
            moreVideoAttr: { // video标签属性
                crossOrigin: 'anonymous'
            },
            screenshotPrefix: 'live_capture',
            fullscreenRotate: true,

            // 主体色
            theme: '#ff3355',
            selectorTheme: '#ff3355',

            url, // 流地址
            isLive: true, // 直播场景
            muted: true, // 静音
            autoplay: true, // 自动播放
            type: 'flv',

            // 附加的MIME
            customType: {
                flv: function (video, url) {
                    let flvPlayer = flvPlayerRef.current;

                    if (flvPlayer) {
                        flvPlayer.pause();
                        flvPlayer.unload();
                        flvPlayer.detachMediaElement();
                        flvPlayer.destroy();
                    }

                    flvPlayer = hkMpegts.createPlayer({
                        type: 'flv',
                        isLive: true,
                        url: url.replace('http:', 'https:')
                    });
                    flvPlayer.attachMediaElement(video);
                    flvPlayer.load();
                    flvPlayer.on(hkMpegts.Events.LOADING_COMPLETE, (...args) => {
                        console.log('LOADING_COMPLETE', args);
                    });
                    flvPlayer.on(hkMpegts.Events.MEDIA_INFO, (...args) => {
                        console.log('MEDIA_INFO', args);
                    });
                    flvPlayer.on(hkMpegts.Events.METADATA_ARRIVED, (...args) => {
                        console.log('METADATA_ARRIVED', args);
                    });
                    flvPlayer.on(hkMpegts.Events.RECOVERED_EARLY_EOF, (...args) => {
                        console.log('RECOVERED_EARLY_EOF', args);
                    });
                    flvPlayer.on(hkMpegts.Events.SCRIPTDATA_ARRIVED, (...args) => {
                        console.log('SCRIPTDATA_ARRIVED', args);
                    });

                    // 画面卡死（非暂停状态下，画面不动5s，重新拉流）
                    let lastDecodedFrames = -1;
                    let lastDecodedTime = Date.now();
                    flvPlayer.on(hkMpegts.Events.STATISTICS_INFO, data => {

                        if (data.decodedFrames > 0) {
                            const now = Date.now();
                            const diffTime = now - lastDecodedTime;

                            if (lastDecodedFrames !== data.decodedFrames) {
                                lastDecodedFrames = data.decodedFrames;
                                lastDecodedTime = now;
                            }
                            else if (!video.paused && diffTime > 5000) {
                                console.log('Reflow > frames has not changed in 5s...');
                                $art.emit('bdlive:refresh');
                            }
                        }
                    });

                    // loading、卡顿、网络波动、断流，尝试重新拉流
                    flvPlayer.on(hkMpegts.Events.ERROR, (errorType, errorDetail, errorInfo) => {
                        console.log('ERROR > ', errorType, errorDetail, JSON.stringify(errorInfo));
                        $art.emit('bdlive:refresh');
                    });
                    flvPlayerRef.current = flvPlayer;
                    return flvPlayer;
                }
            }
        });

        // art初始完后
        $art.loading.show = true;
        $art.once('ready', () => {
            $art.loading.show = false;

            // 刷新按钮插件
            $art.controls.add(
                refreshBtn({
                    name: 'refreshBtn',
                    disable: false,
                    position: 'left',
                    index: 30
                }),
            );
        });

        // 通过switchUrl切换视频时触发
        $art.on('switch', url => {
            $art.option.url = url;
        });

    };
    return (
        <div id='flv-video-container' />
    );
};

const refreshBtn = (option) => {
    return art => {
        const {
            events: {proxy}
        } = art;
        const {query} = hkArtplayer.utils;

        return {
            ...option,
            html: `
                <div
                    class="art-control plugin-refresh"
                    data-balloon-pos="up"
                    aria-label="刷新"
                >
                    <div></div>
                </div>
            `,
            mounted: $control => {
                const refreshDom = query('.plugin-refresh', $control);

                proxy(refreshDom, 'click', () => art.emit('bdlive:refresh'));

                art.on('bdlive:refresh', () => {
                    art.loading.show = true;
                    art.player.switchUrl(art.option.url);
                });
            }
        };
    };
};

export default FlvPlayer;